<template>
  <div>
    <div v-show="!src" class="message_verification">
      <div class="title_text">请完成校验</div>
      <div class="content">为保护客户的隐私安全，请输入客户预留的联系方式后四位进行验证</div>
      <div class="input_value">
        <input id="first" type="number" :max="1" v-model="code[0]"/>
        <input id="second" type="number" :max="1" v-model="code[1]" />
        <input id="third" type="number" :max="1" v-model="code[2]"/>
        <input id="forth" type="number" :max="1" v-model="code[3]" />
      </div>
      <cube-button :loding="loding" @click="handleOk" :disabled="messageCode.length < 4" :class="messageCode.length === 4 && 'active'">提交</cube-button>
    </div>
    <pdf v-show="src" v-for="i in numPages" :key="i" :src="src" :page="i">
    </pdf>
  </div>
</template>

<script>
import pdf from 'vue-pdf-signature';
import CMapReaderFactory from 'vue-pdf-signature/src/CMapReaderFactory.js'

export default {
  name: 'App',
  components: {
    pdf,
  },
  data() {
    return {
      code: new Array(4),
      messageCode: '',
      codeId: ['first','second','third','forth'],
      loding: false,
      src:'',
      numPages: 1,
    }
  },
  mounted() {
    document.getElementById(this.codeId[0]).focus();
  },
  watch:{
    code(newValue){
      const inputValue = newValue.join('');
      if (inputValue.length > 4) {
        newValue = inputValue.slice(0, 4).split('')
        this.$nextTick(() => {
          this.code = newValue;
        })
      } else {
        const tempValue = inputValue.split('')
        for(let i = 0; i < newValue.length; i++){
          if(tempValue[i] && i < 4) {
            newValue[i] = tempValue[i]
          } else {
            newValue[i] = ''
          }
        }
      }
      this.messageCode = newValue.join('');
      let location = inputValue.length;
      if(location < 1){
        location = 1
      } else if (location > 4){
        location = 4
      }
      document.getElementById(this.codeId[location - 1]).focus()
    }
  },

  methods: {
    handleOk() {
      if(this.messageCode.length !== 4){
        return
      }
      this.loding = true;
      let id = '';
      if(location.host === "app.zhaoshang800.com") {
        id = window.location.pathname.split('/').pop();
      } else {
        id = window.location.hash.split('/')[1];
      }
      this.$http({
        url:`/app/fileDownloadVerification/download/${id}`,
        method:'post',
        responseType: 'blob',
        data: {
          verificationCode: this.messageCode,
        }
      })
      .then(async (res) => {
        this.loding = false;
        const type = res.headers['content-type'].split(';');
        if (type.length && type[0] === 'application/json') {
          let resBlob;
          const blob = new Blob([res.data],{type: 'application/json'}).text();
          await blob.then((blob) => {
            resBlob = JSON.parse(blob)
          })
          if(resBlob.code !== 200){
            this.$createDialog({
              type: 'alert',
              title: '输入错误，请确认后再次输入！',
              confirmBtn: {
                text: '我知道了',
                active: true
              },
              onConfirm: () => {
                this.code = new Array(4)
              }
            }).show()
          }
        } else {
          const blob = new Blob([res.data],{ type: 'application/pdf' });
          const src = window.URL.createObjectURL(blob)
          this.pdfTask(src)
          window.URL.revokeObjectURL(blob);
        }
      })
      .catch((error) => {
        this.loding = false;
        this.$createToast({
          txt: error.data ? error.data.msg : '请求错误',
          type: 'txt'
        }).show()
      });
    },
    pdfTask(pdfUrl){
      this.src = pdf.createLoadingTask({url: pdfUrl, CMapReaderFactory})  
      this.src.promise.then(pdf => {
        this.numPages = pdf.numPages 
      }).catch((err) => {
        this.$createToast({
          txt: 'pdf加载失败',
          type: 'txt'
        }).show()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/style/mixin.scss";
@import "@/style/function.scss";
.message_verification {
  padding: 0 px2rem(32px);
  .title_text {
    vertical-align: bottom;
    font-size: px2rem(48px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: px2rem(66px);
    padding-top: px2rem(160px);
  }
  .content {
    line-height: 1.5;
    padding-bottom: px2rem(100px);
    padding-top: px2rem(24px);
    font-size: px2rem(24px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #AAAAAA;
  }
  .input_value {
    display: flex;
    justify-content: space-evenly;
    input {
      display: inline-block;
      width: px2rem(140px);
      height: px2rem(140px);
      text-align:center;
      border: none;
      background: #F8F8F8;
      border-radius: 10px;
      outline: none;
      font-size: px2rem(40px);
    }
  }
  .cube-btn {
    margin-top: px2rem(140px);
    padding: px2rem(28px)  0;
    background: #FF3333;
    font-size: px2rem(32px);;
    line-height: 1;
    opacity: .5;
    border-radius: px2rem(10px);
    &.active {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?276de427